export default __webpack_public_path__ + "cd19306a1db6cc4cde74c169b717efa6.png";